import { type FC } from 'react';

import { MoreActions } from '@widgets/merchant';

import { DecisionBadge } from '@entities/merchant';

import { Box, Flex, Text } from '@shared/ui-kit';

import { MerchantDecisionState } from '@api/services/merchants';

interface Props {
  id: string;
  name: string;
  decision: MerchantDecisionState;
  decision_applied_at?: string;
  decision_applied_full_name?: string | null;
}

const CardHeader: FC<Props> = (props) => {
  const {
    id,
    name,
    decision,
    decision_applied_at,
    decision_applied_full_name,
  } = props;

  return (
    <Flex
      alignItems="flex-start"
      justifyContent="space-between"
      columnGap="9"
    >
      <Text
        className="ym-hide-content"
        position="relative"
        zIndex="1"
        fontSize="lg"
        fontWeight="bold"
        data-qa-selector="merchant_name"
        data-testid="merchant_name"
        wordBreak="break-word"
        cursor="text"
      >
        {name}
      </Text>
      <Flex
        alignItems="center"
        columnGap="2.5"
      >
        <Box className="fg-of-link">
          <DecisionBadge
            merchant_id={id}
            decision={decision}
            decision_applied_at={decision_applied_at}
            decision_applied_full_name={decision_applied_full_name}
          />
        </Box>
        <MoreActions merchantId={id} />
      </Flex>
    </Flex>
  );
};

export default CardHeader;
